import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Agent, AgentClient, AgentService, DocumentAgents, DocumentAgentsClient, DocumentClient, Documents, DocumentServiceClient, DocumentServiceProviderClient, DocumentServiceProviders, DocumentServices, DocumentTypeClient, DocumentTypes, Material, MaterialClient, MechanisationClient, Mechanisations, NServices, ServiceClient, ServiceProvider, ServiceProvidersClient, Unit, VIKUnitClient } from "src/app/web-api-client";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Subject } from "rxjs";

@Component({
  selector: 'app-mechanisation-creation',
  templateUrl: './mechanisation-creation.component.html',
  styleUrls: ['./mechanisation-creation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MechanisationCreationComponent implements OnInit  {

  public includeDocument: boolean = false;
  public step: number = 1;
  public isLoaded = false;
  public services: Mechanisations[]; 
  Form: FormGroup;


  public onClose = new Subject<boolean>();

  constructor(private fb: FormBuilder,public changeDetecRef:ChangeDetectorRef,public activeModal: NgbActiveModal,public client:MechanisationClient) { }

  ngOnInit(): void {

    
      this.initializeForm();
      this.isLoaded = true;
      this.changeDetecRef.detectChanges();
  
  }

  initializeForm() {


    this.Form = this.fb.group({
      title: ['', Validators.required],
      description: ['', Validators.required],  
      totalQuantity: [0, Validators.required],
      isActive: [null, Validators.required]
    });


  }

  closeModal() {
    this.onClose.next(true);
    this.activeModal.close();
  }

  onSubmit() {
    if (this.Form.valid) {

      let service =new Mechanisations();

      service.id = 0;
      service.title = this.Form.value.title;
      service.description = this.Form.value.description; 
      service.totalQuantity = this.Form.value.totalQuantity; 
      service.isActive = this.Form.value.isActive; 




      this.client.create(service).subscribe((result) => {

          this.onClose.next(true);
          this.activeModal.close();
      });
    }
  } 
   

}
